import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { Button } from "@mantine/core";
import NavMenu from "components/NavMenu/NavMenu";

const StyledPage = styled.div`
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-main);
`;

const Header = styled.header`
  width: 100%;
  // border-bottom: 1px solid var(--border-color);
  background-color: var(--bg-main);
`;

const HeaderContainer = styled.div`
  max-width: 1320px;
  margin: 0 auto;
  padding: 3rem 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
`;

const LogoLink = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  text-decoration: none;
  letter-spacing: -0.03rem;
  border-bottom: none;

  &:hover {
    color: var(--accent);
    border-bottom: none;
  }
`;

const Canvas = styled.main`
  flex: 1;
  width: 100%;
  max-width: 1320px;
  margin: 0 auto;
  padding: 2.5rem 1.5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export default function Page(props) {
  const [width, setWidth] = useState(window.innerWidth);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const mobileLayout = width < 768;

  return (
    <StyledPage>
      {showMobileMenu && mobileLayout && (
        <NavMenu variant="overlay" onClose={() => setShowMobileMenu(false)} />
      )}
      
      <Header>
        <HeaderContainer>
          {/* <LogoLink to="/" exact>
            <span>Sjur Sundin</span>
          </LogoLink>
          
          {mobileLayout ? (
            <Button
              variant="outline"
              color="dark"
              size="xs"
              radius="xs"
              styles={{
                root: {
                  borderColor: "var(--border-color)",
                  color: "var(--text-primary)",
                  fontFamily: "IBM Plex Sans",
                  textTransform: "uppercase",
                  letterSpacing: "0.05rem",
                  "&:hover": {
                    borderColor: "var(--accent)",
                    backgroundColor: "transparent",
                  }
                }
              }}
              onClick={() => setShowMobileMenu(true)}
            >
              menu
            </Button>
          ) : (
            <NavMenu variant="horizontal" />
          )} */}
        </HeaderContainer>
      </Header>
      
      <Canvas>
        {props.children}
      </Canvas>
    </StyledPage>
  );
}
